(function () {
  if (window.Shopify && window.Shopify.designMode) return;
  var FORM_ID = 'VzZxxc';
  function openForm() {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', FORM_ID]);
  }
  function openTwice() { openForm(); setTimeout(openForm, 1200); }

  // Claim 10% Off button: any link pointing at a kk_newsletter URL opens the popup instead of navigating
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href*="kk_newsletter"]') : null;
    if (a) { e.preventDefault(); openTwice(); }
  });
  // Direct navigation to a kk_newsletter URL opens the popup
  if (/kk_newsletter/.test(window.location.search)) {
    if (document.readyState === 'complete') { openTwice(); }
    else { window.addEventListener('load', openTwice); }
  }
  // Timed auto-show, once per 30 days per visitor (all devices)
  if (document.cookie.indexOf('kk_pop_seen=1') === -1) {
    setTimeout(function () {
      openForm();
      var d = new Date();
      d.setTime(d.getTime() + 2592000000);
      document.cookie = 'kk_pop_seen=1; expires=' + d.toUTCString() + '; path=/';
    }, 6000);
  }

  // Minimized "Get 10% Off" tab.
  // Desktop: appears after the popup is closed (the header button is the primary claim path).
  // Mobile (< 768px, where the theme hides the header button): always visible as the tap-to-claim button.
  function buildTeaser() {
    if (document.getElementById('kk-teaser')) return document.getElementById('kk-teaser');
    var t = document.createElement('button');
    t.id = 'kk-teaser';
    t.type = 'button';
    t.textContent = 'Get 10% Off';
    t.setAttribute('aria-label', 'Get 10% off - open newsletter signup');
    var s = t.style;
    s.position = 'fixed';
    s.left = '50%';
    s.bottom = '0';
    s.transform = 'translateX(-50%)';
    s.zIndex = '2147482000';
    s.display = 'none';
    s.padding = '12px 26px';
    s.background = '#2f3b42';
    s.color = '#ffffff';
    s.border = 'none';
    s.borderTopLeftRadius = '10px';
    s.borderTopRightRadius = '10px';
    s.fontFamily = "Montserrat, Arial, sans-serif";
    s.fontSize = '15px';
    s.fontWeight = '600';
    s.lineHeight = '1';
    s.letterSpacing = '.02em';
    s.cursor = 'pointer';
    s.boxShadow = '0 -2px 12px rgba(0,0,0,.18)';
    t.addEventListener('click', function () { openTwice(); });
    if (document.body) document.body.appendChild(t);
    return t;
  }
  function isPopupOpen() {
    return document.body.classList.contains('klaviyo-prevent-body-scrolling') ||
           document.documentElement.classList.contains('klaviyo-prevent-body-scrolling');
  }
  function isMobile() {
    return window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
  }
  var hasBeenOpen = false;
  function syncTeaser() {
    var t = document.getElementById('kk-teaser') || buildTeaser();
    if (!t) return;
    if (isPopupOpen()) { hasBeenOpen = true; t.style.display = 'none'; }
    else if (hasBeenOpen || isMobile()) { t.style.display = 'block'; }
    else { t.style.display = 'none'; }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildTeaser);
  } else {
    buildTeaser();
  }
  setInterval(syncTeaser, 400);
})();
